import templateUrl from './edit-onboarding-policy-document-group-modal.html'

export const EditOnboardingPolicyDocumentGroupModalComponent = {
    controller: EditOnboardingPolicyDocumentGroupModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl
}

function EditOnboardingPolicyDocumentGroupModalController(onboardingPolicyService, utilityService) {
    'ngInject'
    const vm = this;
    vm.$onInit = onInit;
    vm.filterResult = filterResult;
    vm.onMoveItem = onMoveItem;
    vm.onSave = onSave;

    function onInit() {
        vm.documentGroup = vm.resolve.documentGroup;
        vm.index = vm.resolve.index;
        vm.onboardingPolicy = vm.resolve.onboardingPolicy;
        vm.isNew = vm.resolve.isNew;
        vm.sortIndexMode = 'bottom';

        if (vm.isNew) {
            // Generate a new array consisting of the old array concatenated with the new value.
            // Then insert the item into its resolved sort index.
            vm.results = vm.onboardingPolicy.OnboardingDocumentGroups.concat([vm.documentGroup]);
            utilityService.moveItem(vm.results, vm.documentGroup, vm.documentGroup.SortIndex);
        } else {
            vm.results = vm.onboardingPolicy.OnboardingDocumentGroups.map(function (documentGroup, i) {
                return i === vm.index ? vm.documentGroup : documentGroup;
            });
        }
    }

    function onMoveItem(items, selectedItem, index) {
        utilityService.moveItem(items, selectedItem, index);
        selectedItem.SortIndex = index;
    }

    function onSave() {
        validateChange();
        if (vm.editForm && vm.editForm.$invalid) {
            alert("Cannot save: validation errors in form");
        }

        if (vm.isNew && !confirm("The document group will be added to this list. This cannot be undone. Continue?")) {
            return;
        }

        const request = {
            Name: vm.documentGroup.Name,
            SortIndex: vm.sortIndexMode === 'specific' ? vm.documentGroup.SortIndex : null,
            RequirementsFileUpload: vm.documentGroup.RequirementsFileUpload
        };

        const saved = vm.isNew
            ? onboardingPolicyService.addDocumentGroup(vm.onboardingPolicy.OnboardingPolicyID, request)
            : onboardingPolicyService.updateDocumentGroup(vm.onboardingPolicy.OnboardingPolicyID,
                vm.documentGroup.OnboardingPolicyDocumentGroupID, request);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(saved, "Save failed"));

        return saved.then(function (id) {
            if (vm.isNew) {
                request.OnboardingPolicyDocumentGroupID = id;
            }
            vm.close({ $value: request });
        })
    }

    function validateChange() {
        if (!vm.editForm) {
            return;
        }
    }

    function filterResult(result) {
        return result !== vm.documentGroup || vm.sortIndexMode === 'specific';
    }
}
